import { Pipe, PipeTransform } from '@angular/core';
/**
 * CapitalizeWordsPipe
 * Transforms string to capitalize words
 * example 1: 'helloWorld' => 'Hello World'
 * example 2: 'hello_world' => 'Hello World'
 * example 3: 'hello-world' => 'Hello World'
 * example 4: 'hello.world' => 'Hello World'
 */
@Pipe({
  name: 'sgCapitalizeWords',
  standalone: false,
})
export class SgCapitalizeWordsPipe implements PipeTransform {
  transform(value: string): string {
    return this.toCapitalizedWords(value);
  }

  toCapitalizedWords(word: string) {
    const regex = new RegExp(`[A-Za-z][a-z]*`, 'g');
    const words = word.match(regex) || [];
    return words.map(this.capitalize).join(' ');
  }

  capitalize(word: string) {
    return word.charAt(0).toUpperCase() + word.substring(1);
  }
}
